import {BASE_SERVICE_URL} from '../lib/constants'

export default function load(uid) {
    return fetch(BASE_SERVICE_URL + `/${uid}`, {
        credentials: 'same-origin',
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}
